module.exports = __webpack_public_path__ + "img/thumb_tablet_full.3a069075.png";